/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_picture } from '../models/Body_upload_picture';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DefaultService {

    /**
     * Upload Picture
     * @param folder
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadPicture(
        folder: string,
        formData: Body_upload_picture,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/back/upload/picture',
            query: {
                'folder': folder,
            },
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
